var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block fill-current",domProps:{"innerHTML":_vm._s(require(("@/assets/images/svg/hatchery/" + _vm.name + ".svg")).default)}})}
var staticRenderFns = []

export { render, staticRenderFns }